export default [
  [`Размеры`, `S`, `M`, `L`, `XL`, `2XL`],
  [`Рост`, `168`, `172`, `176`, `180`, `184`],
  [`Грудь`, `43`, `45`, `47`, `49`, `51`],
  [`Длина`, `60`, `62`, `64`, `66`, `68`]
];
